core-radio-button {
  display: flex;
}

.core-radio-button {
  display: flex;
  align-items: flex-start;
  gap: var(--number-spacing-2xsmall);
}

.core-radio-button .radio-button-wrapper {
  display: flex;
  padding: var(--number-spacing-5xsmall);
  justify-content: center;
  align-items: center;
}

.core-radio-button.radio-button--disabled .radio-button-box {
  cursor: not-allowed;
}

.core-radio-button .radio-button-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  box-sizing: border-box;
  border: 1px solid var(--color-selection-primary-border-default);
  border-radius: var(--number-radius-round);
  background-color: var(--color-selection-primary-background-default);
  cursor: pointer;
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move),
    border var(--motion-duration-fast) var(--motion-easing-move);
}

.core-radio-button.radio-button--checked:not(.radio-button--disabled) .radio-button-box, .core-radio-button.radio-button--indeterminate:not(.radio-button--disabled) .radio-button-box {
  background-color: var(--color-selection-primary-background-selected);
  border-color: var(--color-selection-primary-border-selected);
}

.core-radio-button:not(.radio-button--disabled) .radio-button-box:hover,
.core-radio-button:not(.radio-button--disabled) .radio-button-box:focus-visible {
  border: 1px solid var(--color-selection-primary-border-interacting);
  background-color: var(--color-selection-primary-background-interacting);
}

.core-radio-button.radio-button--disabled .radio-button-box {
  border-color: transparent;
  background: var(--color-global-all-disabled-soft);
}

.core-radio-button .radio-button-box:focus-visible {
  outline: 2px solid var(--color-global-border-focus);
  outline-offset: 2px;
}

.core-radio-button .radio-button-box svg {
  fill: var(--color-selection-primary-content-selected);
  animation: appear var(--motion-duration-medium) var(--motion-easing-enter);
  transition: fill var(--motion-duration-fast) var(--motion-easing-move);
}

.core-radio-button.radio-button--disabled .radio-button-box svg {
  fill: var(--color-global-all-disabled-strong);
}

.core-radio-button:not(.radio-button--disabled) .radio-button-box:hover svg,
.core-radio-button:not(.radio-button--disabled) .radio-button-box:focus-visible svg {
  fill: var(--color-selection-primary-content-interacting);
}

.core-radio-button .infos-box {
  display: flex;
  flex-direction: column;
}

.core-radio-button .radio-button-label, .core-radio-button .radio-button-description {
  color: var(--color-neutral-content-medium);
}

@keyframes appear {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
